import React from "react";
import { Layout } from "antd";
import { Categories } from "./Categories";
import { Intro } from "./Intro";

export const Mainpage = () => (
    <Layout>
        <Intro/>
        <Categories/>
    </Layout>
)


// WEBPACK FOOTER //
// ./src/components/pages/mainpage/Mainpage.js